import React from 'react';

import { Flex, FlexProps, Loader, Text } from '@mantine/core';

interface FullScreenLoaderProps extends FlexProps {
  dark?: boolean;
  message?: string;
}

export function FullScreenLoader({ dark = false, message, ...flexProps }: FullScreenLoaderProps) {
  return (
    <Flex
      h="100svh"
      w="100%"
      {...flexProps}
      align="center"
      justify="center"
      sx={(theme) => ({
        backgroundColor: dark ? theme.other.drakBackground : theme.white
      })}>
      <Flex direction="column" justify="center" align="center">
        <Loader variant="dots" size="xl"></Loader>
        {message && (
          <Text mt="md" align="center" maw={300}>
            {message}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
